import aishaPic from "@/public/images/artists/aisha.png";
import { Artist } from "@/types/types";

export const aisha = {
  id: "292",
  name: "Aisha",
  image: aishaPic,
  description: `Aisha has a distinctive voice with pronounced vibrato, airy highs, and rich, emotionally driven phrasing.`,
  previewUrl:
    "https://public-assets.audimeestorage.com/artistPreviews%2Faisha-preview.mp3",
  meta: {
    free: false,
    new: false,
  },
  filters: {
    gender: "Female",
    tags: {
      primary: ["Unprocessed", "Soul", "Dance", "Pop", "RnB", "Disco"],
      secondary: [],
    },
    pitchRange: {
      categories: {
        low: "High",
        high: "Very high",
      },
      specific: {
        low: 56,
        high: 73,
      },
      sweetSpot: 64,
    },
  },
} as const satisfies Artist;
